// Chinese names for the countries and cities we sell in. Shown next to the English name when 中文 is chosen,
// so a customer can still match what they see to our English emails, API and support chat.
// A new city simply shows its English name until it is added here.
import { locale } from './index';

const COUNTRIES = {
    'Australia': '澳大利亚', 'Austria': '奥地利', 'Belgium': '比利时', 'Canada': '加拿大', 'Czech Republic': '捷克',
    'Denmark': '丹麦', 'Finland': '芬兰', 'France': '法国', 'Germany': '德国', 'Ireland': '爱尔兰', 'Italy': '意大利',
    'Japan': '日本', 'Netherlands': '荷兰', 'Norway': '挪威', 'Poland': '波兰', 'Portugal': '葡萄牙', 'Romania': '罗马尼亚',
    'Singapore': '新加坡', 'Spain': '西班牙', 'Sweden': '瑞典', 'Switzerland': '瑞士',
    'United Kingdom': '英国', 'United States': '美国', 'USA': '美国', 'UK': '英国',
};

// longest names first, so "New York City" wins over "York" and "Houston Texas" over "Houston"
const CITIES = Object.entries({
    // UK
    'Birmingham': '伯明翰', 'Bristol': '布里斯托尔', 'Cardiff': '加的夫', 'Carlisle': '卡莱尔', 'Chippenham': '奇彭纳姆',
    'Crewe': '克鲁', 'Leeds': '利兹', 'Leicester': '莱斯特', 'London': '伦敦', 'Manchester': '曼彻斯特',
    'Newcastle': '纽卡斯尔', 'Northampton': '北安普敦', 'Nottingham': '诺丁汉', 'Rugby': '拉格比', 'Wales': '威尔士',
    'Liverpool': '利物浦', 'Sheffield': '谢菲尔德', 'Glasgow': '格拉斯哥', 'Edinburgh': '爱丁堡',
    // Europe
    'Nice': '尼斯', 'Toulouse': '图卢兹', 'Paris': '巴黎', 'Lyon': '里昂', 'Marseille': '马赛',
    'Berlin': '柏林', 'Frankfurt': '法兰克福', 'Munich': '慕尼黑', 'Hamburg': '汉堡',
    'Cork': '科克', 'Dublin': '都柏林', 'Amsterdam': '阿姆斯特丹', 'Groningen': '格罗宁根', 'Rotterdam': '鹿特丹',
    'Poznań': '波兹南', 'Poznan': '波兹南', 'Warsaw': '华沙', 'Barcelona': '巴塞罗那', 'Madrid': '马德里',
    // Australia
    'Perth': '珀斯', 'Sydney': '悉尼', 'Melbourne': '墨尔本', 'Brisbane': '布里斯班',
    // United States
    'Houston Texas': '休斯顿（得克萨斯州）', 'Houston': '休斯顿', 'Boston Massachusetts': '波士顿（马萨诸塞州）', 'Boston': '波士顿',
    'Chicago': '芝加哥', 'Los Angeles California': '洛杉矶（加利福尼亚州）', 'Los Angeles': '洛杉矶',
    'Miami Florida': '迈阿密（佛罗里达州）', 'Miami': '迈阿密', 'New York City': '纽约市', 'New York': '纽约',
    'North Carolina': '北卡罗来纳州', 'Phoenix Arizona': '菲尼克斯（亚利桑那州）', 'Phoenix': '菲尼克斯',
    'Dallas': '达拉斯', 'Atlanta': '亚特兰大', 'Seattle': '西雅图', 'Denver': '丹佛',
}).sort((a, b) => b[0].length - a[0].length);

const escapeRe = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

// Chinese name of a country, or '' when unknown or when English is selected
export function countryZh(name) {
    if (locale.value !== 'zh-CN') return '';
    return COUNTRIES[String(name || '').trim()] || '';
}

// Chinese name of a city; sales suffixes such as "IPV6", "5G" or "(UDP over SOCKS5)" are kept as they are
export function cityZh(name) {
    if (locale.value !== 'zh-CN') return '';
    const s = String(name || '');
    for (const [en, zh] of CITIES) {
        const re = new RegExp('(^|[^A-Za-z])' + escapeRe(en) + '(?![A-Za-z])', 'i');
        if (re.test(s)) return s.replace(re, (m, pre) => pre + zh).replace(/\s{2,}/g, ' ').trim();
    }
    return '';
}
